import React, { useEffect, useRef, useState } from "react"
import ReactPlayer from "react-player"
import * as classNames from "./ImageVideo.module.scss"
import Image from "../../lib/common/blocks/image/Image"

function ImageVideo({ imageVideoData }) {
  const [isMounted, setIsMounted] = useState(false)

  const typeVideo = imageVideoData?.typeVideo
  const [isVideoPlaying, setIsVideoPlaying] = useState(false)
  const videoRef = useRef(null)
  let player
  useEffect(() => {
    setIsMounted(true)
    if (videoRef.current) {
      player = videoRef.current.getInternalPlayer()
    }
  }, [videoRef])

  const handleMouseEnter = () => {
    if (typeVideo === "Ambiance") {
      setIsVideoPlaying(true)
    }
  }

  const handleMouseLeave = () => {
    if (typeVideo === "Ambiance") {
      setIsVideoPlaying(false)
    }
  }
  const handleImageClick = () => {
    if (typeVideo !== "Ambiance") {
      setIsVideoPlaying(true)
      videoRef.current.seekTo(0)
    }
  }

  const getControls = () => {
    if (typeVideo === "Focus") {
      return true
    } else if (typeVideo === "Ambiance") {
      return false
    }
    return true
  }

  const getMute = () => {
    if (typeVideo === "Ambiance") {
      return true
    } else if (typeVideo === "Focus") {
      return false
    }
    return false
  }

  const handleFocuseMediaClickEvents = () => {
    if (videoRef.current) {
      const player = videoRef.current.getInternalPlayer()
      if (player) {
        player.paused ? player.play() : player.pause()
      }
    }
  }

  return (
    <div className="col mt-4 mt-md-0">
      {imageVideoData?.video?.data !== null || imageVideoData?.videoExternal ? (
        <>
          {isMounted && (
            <div
              className={`${classNames.video} pin-6 pb-3`}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <ReactPlayer
                ref={videoRef}
                controls={getControls()}
                loop
                width={"100%"}
                height={"100%"}
                url={
                  imageVideoData?.video.data?.attributes?.url ||
                  imageVideoData?.videoExternal
                }
                alt={imageVideoData?.video.data?.attributes?.alternativeText}
                light={
                  imageVideoData?.image.data?.attributes.url &&
                  typeVideo === "Focus" ? (
                    <Image
                      dataSizesPreset={"hero"}
                      imgSrc={imageVideoData?.image.data?.attributes?.url}
                      imgAlt={imageVideoData?.image.data?.attributes?.alternativeText}
                      imgWidth={imageVideoData?.image.data?.attributes?.width}
                      imgHeight={imageVideoData?.image.data?.attributes?.height}
                      formats={imageVideoData?.image.data?.attributes?.formats}
                      onMouseEnter={handleImageClick}
                      style={{ cursor: "pointer" }}
                    />
                  ) : (
                    false
                  )
                }
                playsinline
                playing={isVideoPlaying}
                muted={getMute()}
                config={{
                  youtube: {
                    playerVars: {
                      controls: typeVideo === "Focus" ? 1 : 0,
                      modestbranding: 1,
                    },
                  },
                }}
              />
            </div>
          )}
        </>
      ) : imageVideoData?.image?.data !== null ? (
        <>
          <Image
            dataSizesPreset={"hero"}
            imgSrc={imageVideoData?.image.data?.attributes?.url}
            imgAlt={imageVideoData?.image.data?.attributes?.alternativeText}
            imgWidth={imageVideoData?.image.data?.attributes?.width}
            imgHeight={imageVideoData?.image.data?.attributes?.height}
            formats={imageVideoData?.image.data?.attributes?.formats}
          />
        </>
      ) : null}
    </div>
  )
}

export default ImageVideo
